import previewDark from "assets/images/Style-Preview-Dark.png";
import previewGrayscale from "assets/images/Style-Preview-Greyscale.png";
import previewMap from "assets/images/Style-Preview-Map.png";
import previewSatellite from "assets/images/Style-Preview-Satellite.png";
import previewTerrain from "assets/images/Style-Preview-Terrain.png";
import mapboxgl from "mapbox-gl";

import { BaseLayerKind } from "components/map/contexts/MapContextState";

export const BASE_LAYER_OPTIONS: {
  label: string;
  value: BaseLayerKind;
  // Preview thumbnail shown in the Map Style dropdown. "None" has no preview.
  preview?: string;
}[] = [
  { label: "Map", value: "Street", preview: previewMap },
  { label: "Satellite", value: "Satellite", preview: previewSatellite },
  { label: "Terrain", value: "Terrain", preview: previewTerrain },
  { label: "Grayscale", value: "Grayscale", preview: previewGrayscale },
  { label: "Dark", value: "Dark", preview: previewDark },
  { label: "None", value: "None" }
];

export function getBaseLayerStyleUrl(layer: BaseLayerKind): string | mapboxgl.Style {
  switch (layer) {
    case "Satellite":
      return "mapbox://styles/mapbox/satellite-v9";
    case "Terrain":
      return "mapbox://styles/hoda99/ckl5ypgg102e817s5wbnqcly6";
    case "Grayscale":
      return "mapbox://styles/mapbox/light-v10";
    case "Dark":
      return "mapbox://styles/mapbox/dark-v10";
    case "None":
      return {
        version: 8,
        sources: {},
        layers: [],
        glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
      };
    case "Street":
    default:
      return "mapbox://styles/mapbox/streets-v11";
  }
}
